export default __webpack_public_path__ + "static/media/television.2f635a52.svg";